import React, { useState,useEffect } from "react";
import { Link } from "react-router-dom";
import { Container, Row, Col, Button, Modal, Carousel } from "react-bootstrap";
import { FaFacebook, FaTiktok, FaYoutube, FaInstagram, FaArrowLeft, FaArrowRight } from "react-icons/fa";


const LatestUpdates = () => {
    return (
        <>
            <div className="container text-center py-5">
                <h2 className="mb-3">Latest Updates</h2>
                <div className="text-primary fs-3">★</div>

                <div className="row g-4 mt-4">
                    {/* First Card */}
                    {[
                        {
                            title: "Professional Year",
                            text: "The Professional Year Program is a professional development program involving formal learning.",
                            imgSrc: "./img/professional.jpg",
                            link: "/professional"
                        },
                        {
                            title: "Admissions And Course Change",
                            text: "Do you want to take admission in any course? Do you want to change the course?",
                            imgSrc: "./img/course-change.jpg",
                            link: "/coursechange"
                        },
                    ].map((item, index) => (
                        <div key={index} className="col-md-6 col-lg-4">
                            <div className="card shadow-sm border-0 h-100">
                                <img
                                    src={item.imgSrc}
                                    className="card-img-top"
                                    alt={item.title}
                                    style={{ height: "200px", objectFit: "cover" }}
                                />
                                <div className="badge bg-secondary position-absolute m-2">STUDENT SERVICES</div>
                                <div className="card-body d-flex flex-column">
                                    <h5 className="card-title text-primary">{item.title}</h5>
                                    <p className="card-text flex-grow-1">{item.text}</p>
                                    <Link to={item.link} className="text-primary" onClick={() => window.scrollTo(0, 0)}>
                                        READ MORE →
                                    </Link>
                                </div>
                            </div>
                        </div>
                    ))}

                    {/* Subscription Section */}
                    <div className="col-md-6 col-lg-4 d-flex flex-column align-items-center justify-content-center">
                        <img src="./img/brand-logo.png" alt="Brand Logo" className="mb-3" style={{ height: "100px", objectFit: "contain" }} />
                        <h5>Bajwa Immigration Consultants</h5>
                        <p>Subscribe to our YouTube channel for more updates!</p>
                        <button className="btn btn-danger">
                            <a href="https://www.youtube.com/@BAJWAIMMIGRATIONCONSULTANTS" target="_blank" rel="noopener noreferrer" className="text-white text-decoration-none">SUBSCRIBE</a>
                        </button>
                    </div>
                </div>
                <div className="mt-4">
                    <button className="btn btn-danger">
                        <Link to="https://au.bajwaimmigration.com/book-appointment" onClick={() => window.scrollTo(0, 0)} className="text-white text-decoration-none">Book Appointment</Link>
                    </button>
                </div>
            </div>
        </>
    );
};
 
const ContactForm = () => {
    const [formData, setFormData] = useState({
        firstname: "",
        lastname: "",
        countryCode: "",
        phone: "",
        email: "",
        message: "",
        officeGUID: "",
    });

    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);

    const validate = () => {
        let newErrors = {};

        if (!formData.firstname.trim() || formData.firstname.length > 150)
            newErrors.firstname = "First name is required (Max 150 characters)";

        if (!formData.lastname.trim() || formData.lastname.length > 150)
            newErrors.lastname = "Last name is required (Max 150 characters)";

        if (!/^[+]\d{1,3}$/.test(formData.countryCode))
            newErrors.countryCode = "Enter a valid country code (e.g., +61)";

        if (!/^\d{10}$/.test(formData.phone))
            newErrors.phone = "Phone number must be exactly 10 digits";

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email))
            newErrors.email = "Enter a valid email address";

        if (formData.message.length > 500)
            newErrors.message = "Message must be under 500 characters";

        // if (!/^[a-fA-F0-9-]{36}$/.test(formData.officeGUID))
        //     newErrors.officeGUID = "Invalid GUID format";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        setLoading(true);
        try {
            const response = await fetch("https://auapi.bajwaimmigration.com/Website/Enquiry/Create", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            const data = await response.json();
            if (data.status === "Success") {
                alert("Form submitted successfully!");
                setFormData({
                    firstname: "",
                    lastname: "",
                    countryCode: "",
                    phone: "",
                    email: "",
                    message: "",
                    // officeGUID: "",
                });
            } else {
                alert("Submission failed. Please try again.");
            }
        } catch (error) {
            console.error("Error:", error);
            alert("An error occurred. Please try again later.");
        }
        setLoading(false);
    };

    return (
        <>
        <div className="container mt-5">
            <div className="card shadow p-4" style={{ maxWidth: "450px", width: "100%" }}>
                <h3 className="mb-4 text-primary">Contact Us</h3>
                <form onSubmit={handleSubmit}>
                    <div className="mb-3">
                        <label>First Name:</label>
                        <input
                            type="text"
                            name="firstname"
                            value={formData.firstname}
                            onChange={handleChange}
                            className={`form-control ${errors.firstname ? "is-invalid" : ""}`}
                            maxLength="150"
                            required
                        />
                        {errors.firstname && <div className="invalid-feedback">{errors.firstname}</div>}
                    </div>

                    <div className="mb-3">
                        <label>Last Name:</label>
                        <input
                            type="text"
                            name="lastname"
                            value={formData.lastname}
                            onChange={handleChange}
                            className={`form-control ${errors.lastname ? "is-invalid" : ""}`}
                            maxLength="150"
                            required
                        />
                        {errors.lastname && <div className="invalid-feedback">{errors.lastname}</div>}
                    </div>

                    <div className="mb-3">
                        <label>Country Code:</label>
                        <input
                            type="text"
                            name="countryCode"
                            value={formData.countryCode}
                            onChange={handleChange}
                            className={`form-control ${errors.countryCode ? "is-invalid" : ""}`}
                            placeholder="+61"
                            required
                        />
                        {errors.countryCode && <div className="invalid-feedback">{errors.countryCode}</div>}
                    </div>

                    <div className="mb-3">
                        <label>Phone:</label>
                        <input
                            type="text"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            className={`form-control ${errors.phone ? "is-invalid" : ""}`}
                            maxLength="10"
                            required
                        />
                        {errors.phone && <div className="invalid-feedback">{errors.phone}</div>}
                    </div>

                    <div className="mb-3">
                        <label>Email:</label>
                        <input
                            type="email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            className={`form-control ${errors.email ? "is-invalid" : ""}`}
                            required
                        />
                        {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                    </div>

                    <div className="mb-3">
                        <label>Message:</label>
                        <textarea
                            name="message"
                            value={formData.message}
                            onChange={handleChange}
                            className={`form-control ${errors.message ? "is-invalid" : ""}`}
                            rows="4"
                            maxLength="500"
                        />
                        {errors.message && <div className="invalid-feedback">{errors.message}</div>}
                    </div>

                    {/* <div className="mb-3">
                        <label>Office GUID:</label>
                        <input
                            type="text"
                            name="officeGUID"
                            value={formData.officeGUID}
                            onChange={handleChange}
                            className={`form-control ${errors.officeGUID ? "is-invalid" : ""}`}
                            required
                        />
                        {errors.officeGUID && <div className="invalid-feedback">{errors.officeGUID}</div>}
                    </div> */}

                    <button type="submit" className="btn btn-primary w-100" disabled={loading}>
                        {loading ? "Submitting..." : "Submit"}
                    </button>
                </form>
            </div>
        </div>
        <PaginationNav/>
        <LatestUpdates />
        
        </>
    );
};

export default ContactForm;


function PaginationNav() {
    return (
        <>
            <div className="d-flex justify-content-between align-items-center p-3">
                <div className="d-flex align-items-center">
                <a href="/skill"> <FaArrowLeft className="me-2 text-secondary" /></a>
                    <div>
                        <a href="/skill" className="text-primary fw-bold text-decoration-none">PREVIOUS</a>
                        <p className="mb-0 text-muted">Temporary Skill Shortage Visa (Subclass 482)</p>
                    </div>
                </div>

                <div className="border-end mx-3" style={{ height: "20px" }}></div>

                <div className="d-flex align-items-center">
                    <div className="text-end">
                        <a href="/tempactivity" className="text-primary fw-bold text-decoration-none">NEXT</a>
                        <p className="mb-0 text-muted">Temporary Activity Visa (Subclass 408)</p>
                    </div>
                    <a href="/tempactivity">  <FaArrowRight className="ms-2 text-secondary" /></a>
                </div>
            </div>
            <br />
        </>
    );
}

